import { render, staticRenderFns } from "./DetalheValorRecebidoForm.vue?vue&type=template&id=29e3b692&scoped=true&"
import script from "./DetalheValorRecebidoForm.vue?vue&type=script&lang=js&"
export * from "./DetalheValorRecebidoForm.vue?vue&type=script&lang=js&"
import style0 from "./DetalheValorRecebidoForm.vue?vue&type=style&index=0&id=29e3b692&scoped=true&lang=css&"
import style1 from "./DetalheValorRecebidoForm.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e3b692",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VIcon,VRow})
